import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import SearchLogo from "../../assets/logo (2).svg";
import { ButtonGroup, Button } from "react-bootstrap";
import { useContext, useState } from "react";
import { UserContext } from "../../use_context";
import { Link } from "react-router-dom";
import FBIcon from "../../assets/fb.svg";
import InstaIcon from "../../assets/insta.svg";
import LinkedInIcon from "../../assets/in.svg";
import Offcanvas from "react-bootstrap/Offcanvas";
import NavDropdown from "react-bootstrap/NavDropdown";
import { NavLink } from "react-router-dom";

function Header({ onTagClick }) {
  // const [offcanvasOpen, setOffcanvasOpen] = useState(false);

  // const handleOffcanvasToggle = () => {
  //   setOffcanvasOpen(!offcanvasOpen);
  // };
  // const handleOffcanvasClose = () => {
  //   setOffcanvasOpen(false); // Set offcanvasOpen state to false when offcanvas is closed
  // };

  const { workCategoryData } = useContext(UserContext);
  return (
    <header className="wide-container text-dark navigation-wrapper bg-white">
      <Navbar expand="lg" className="nav-row first-row fixed ">
        <Link to="/homepage">
          <Navbar.Brand className="brand-logo">
            <img
              src={SearchLogo}
              width="178"
              height="33"
              alt="React Bootstrap logo"
            />
          </Navbar.Brand>{" "}
        </Link>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Offcanvas
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="end"
          className="home-offcanvas-custom custom-ml"

          // show={offcanvasOpen}
          // onHide={handleOffcanvasClose}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id="offcanvasNavbarLabel">
              {/* <img src={search} className="home-logo" alt="Logo" /> */}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className=" menu list-inline nav-links" id="menu">
                <NavDropdown.Item
                  as={NavLink}
                  to="/office"
                  activeClassName="active"
                  className="text-decoration-none"
                >
                  Office
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={NavLink}
                  to="/works"
                  activeClassName="active"
                  className="text-decoration-none"
                >
                  Works
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={NavLink}
                  to="/news"
                  activeClassName="active"
                  className="text-decoration-none"
                >
                  News
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={NavLink}
                  to="/contact"
                  activeClassName="active"
                  className="text-decoration-none"
                >
                  Contact
                </NavDropdown.Item>
              </Nav>

              {/* <div className="d-flex work-listing-header p-0" >
            <div>
              <img src={FBIcon} />
            </div>
            <div>
              <img src={LinkedInIcon} />{" "}
            </div>
            <div>
              <img src={InstaIcon} />{" "}
            </div>
          </div> */}
            </Navbar.Collapse>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Navbar>

      <div className="sub-menu-wrapper page-loaded search-align ">
        <ButtonGroup className="sub-menu work-list-inline nav-links">
          {workCategoryData.map((category) => (
            <Button
              key={category.id}
              className="btn-link"
              type="button"
              onClick={() => onTagClick(category.id)}
            >
              {category.name}
            </Button>
          ))}
        </ButtonGroup>
      </div>
    </header>
  );
}

export default Header;
